<template>
  <div class="protocol-confirm-content">
    <div class="protocol-confirm-body">
      <div class="protocol-confirm-left-content">
        <CircleWarningIcon class="protocol-confirm-body-icon" />
      </div>
      <div class="protocol-confirm-right-content">
        <div class="protocol-confirm-body-title">
          {{ $t('qing-gou-xuan-xie-yi') }}
        </div>
        <div class="protocol-confirm-body-content">
          <span class="protocol-confirm-body-content-separator">
            {{ $t('wo-yi-yue-du-bing-tong-yi') }}
          </span>
          <Link
            :class="[{ 'force-underline': !isChinese() }]"
            :underline="!isChinese()"
            :href="
              !isChinese()
                ? 'https://protocol.rendora.ai/legal/user'
                : 'https://frontend-protocol.xmov.ai/youyan-v3/user'
            "
            target="_blank"
            name="user"
          >
            {{ $t('mo-fa-you-yan-yong-hu-xie-yi') }}
          </Link>
          <span class="protocol-confirm-body-content-separator">
            {{ $t('he') }}
          </span>
          <Link
            :class="[{ 'force-underline': !isChinese() }]"
            :underline="!isChinese()"
            :href="
              !isChinese()
                ? 'https://protocol.rendora.ai/legal/privacy-policy'
                : 'https://frontend-protocol.xmov.ai/youyan-v3/privacy'
            "
            target="_blank"
            name="policy"
          >
            {{ $t('mo-fa-you-yan-yin-si-zheng-ce') }}
          </Link>
        </div>
      </div>
    </div>
    <div class="protocol-confirm-footer">
      <div class="protocol-confirm-footer-buttons">
        <Button :variant="isMobile ? 'border-back' : 'back'" @click="onCancel" :size="buttonSize">
          {{ $t('qu-xiao') }}
        </Button>
        <Button :variant="'purple'" @click="onConfirm" :size="buttonSize">
          {{ $t('que-ren') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CircleWarningIcon from '@rendora/design/assets/circle-warning.svg?component';
import Button from '@rendora/design/components/button/Button.vue';
import { Link } from '@rendora/design/components/link/index';
import { useBreakpoint } from '@rendora/design/index';
import { isChinese } from '~/utils/area';

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);

const emit = defineEmits<{
  cancel: [];
  confirm: [];
}>();

defineProps<{
  onConfirm: () => void;
}>();

const onCancel = () => {
  emit('cancel');
};

const onConfirm = () => {
  emit('confirm');
};

const buttonSize = computed(() => {
  return isMobile.value ? 'large' : 'default';
});
</script>

<style lang="scss" scoped>
@use '@rendora/design/styles/mixins.scss' as *;

.force-underline {
  text-decoration: underline !important;
}

.protocol-confirm-content {
  @include mobile {
    display: flex;
    flex-direction: column;
    gap: responsive-size(8px);
  }
}

.protocol-confirm-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}

.protocol-confirm-left-content {
  @include mobile {
    display: none;
  }
}

.protocol-confirm-footer-buttons {
  @include tablet-up {
    display: flex;
    gap: 12px;
  }
  @include mobile {
    display: flex;
    flex-direction: column-reverse;
    gap: responsive-size(12px);
    width: 100%;

    button {
      width: 100% !important;
    }
  }
}

.protocol-confirm-body {
  padding: 0 20px 20px 20px;
  gap: 12px;
  display: flex;

  @include mobile {
    padding: responsive-size(20px);
  }
}

.protocol-confirm-body-icon {
  width: 24px;
  height: 24px;
  color: var(--x-purple-6);
}

.protocol-confirm-body-title {
  font-size: var(--x-text-16-size);
  font-weight: var(--x-weight-medium);
  line-height: var(--x-text-16-line-height);
  color: var(--x-text-1);
  margin-bottom: 12px;
  @include mobile {
    margin-bottom: responsive-size(16px);
  }
}

.protocol-confirm-body-content {
  display: flex;
  color: var(--x-text-5);
  font-size: var(--x-text-14-size);
  line-height: var(--x-text-14-line-height);
  gap: 4px;
}
</style>
